import api from "../api";

export interface ImpactStat {
  animation_type: string;
  color_theme: string;
  created_at: string;
  description: string;
  hidden: boolean;
  icon: string;
  id: number;
  title: string;
  updated_at: string;
  updated_by: string;
  value: string;
}

export interface ImpactStatsResponse {
  stats: ImpactStat[];
  success: boolean;
}

export async function fetchImpactStats(): Promise<ImpactStat[]> {
  try {
    const response = await api.get<ImpactStatsResponse>("/impact-stats");
    return response.data.stats.filter((stat) => !stat.hidden);
  } catch (error) {
    console.error("Failed to fetch impact stats:", error);
    return [];
  }
}
